var map = {
	"./img-claim-active.png": "0363",
	"./img-flexibleWelfare-active.png": "4cda",
	"./img-health-active.png": "74b6",
	"./img-insuranceContract-active.png": "297f",
	"./img-integralManage-active.png": "50b9",
	"./img-saveManage-active.png": "e0e7",
	"./img-staffAccountmanage-active.png": "8fbe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb3b";